import React, { useState } from 'react'
import { createUseStyles, ThemeProvider } from 'react-jss'

import View from '../form/View'
import Background from '../form/Background'
import SignupFailed from './SignupFailed'
import SignupForm from './SignupForm'
import SignupCompleted from './SignupCompleted'

import DispatchService from '../../services/DispatcherService'

const useStyles = createUseStyles({
  root: {
    height: '100%',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  background: {
    display: 'none',
    '@media(min-width: 500px)': {
      position: 'absolute',
      display: 'block',
      width: '100%',
      bottom: '40%',
      //top: 0,
      zIndex: 0,
    }
  }
})

function Signup () {
  const styles = useStyles()
  const theme = {
    colors: {
      primary: '#1040C6',
      secondary: '#00BDFF'
    }
  }

  const [ fetching, setFetching ] = useState(false)
  const [ page, setPage ] = useState('form')

  const onSubmit = async (name, password) => {
    try {
      setFetching(true)
      await DispatchService.confirmSignup(name, password)
      setPage('completed')
    } catch (err) {
      console.error(err)
      setPage('failed')
    } finally {
      setFetching(false)
    }
  }

  const renderPageComponent = () => {
    switch (page) {
      case 'form':
        return <SignupForm
          fetching={fetching} 
          onSubmit={onSubmit} 
        />
      case 'failed' :
        return <SignupFailed />
      case 'completed' :
        return <SignupCompleted />
    }
  } 

  return (
    <View className={styles.root}>
      <ThemeProvider theme={theme}>
        <Background className={styles.background} />
        { renderPageComponent() }
      </ThemeProvider>
    </View>
  )
}

export default Signup